import { render, staticRenderFns } from "./SettingsBaseView.vue?vue&type=template&id=e3ba6660&"
import script from "./SettingsBaseView.vue?vue&type=script&lang=ts&"
export * from "./SettingsBaseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports